import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../Common/ModalGeneric";
import AktorerForm from "../AktorerForm";
import OpenModalComponent from "./OpenModalComponent";

import { postAktor } from "../../../actions/aktorerActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";
import { endOfDay } from "date-fns";

const rules = {
  kjoretoyMerkeId:
    "required;hasFormat=[A-Fa-f0-9]{8}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{4}-[A-Fa-f0-9]{12},XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX",
  orgNummer: "required;isNumber;length=9",
  adresse1: "required;minLength=1;maxLength=40",
  adresse2: "minLength=0;maxLength=40",
  poststed: "required;minLength=1;maxLength=40",
  postnummer: "required;minLength=1;maxLength=4",
  aktivertDato: "isDato;isLessThan=deaktivertDato",
  deaktivertDato: "isDato;isLargerThan=aktivertDato",
};

const initState = {
  open: false,
  submitButtonText: "Legg til ny",
  orgNummer: "",
  kjoretoyMerkeId: "",
  aktivertDato: null,
  deaktivertDato: null,
  adresse1: "",
  adresse2: "",
  poststed: "",
  postnummer: "",
  validationError: {},
};

export default function AktorerModal() {
  const dispatch = useDispatch();
  const kjoretoyMerkerRaw = useSelector((state) => state.kjoretoyMerker);
  const kjoretoyMerker = useMemo(
    () => kjoretoyMerkerRaw?.map((km) => ({ id: km.id, navn: km.merke })) ?? [],
    [kjoretoyMerkerRaw],
  );

  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState);
  const openModal = () => update({ open: true });

  const getKjoretoyMerkeNavn = (id) => {
    const found = kjoretoyMerker.find((km) => km.id === id);
    return found ? found.navn : null;
  };

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = () => {
    update({ submitButtonText: "Legger til..." });
    const payload = {
      navn: getKjoretoyMerkeNavn(state.kjoretoyMerkeId),
      orgNummer: parseInt(state.orgNummer), //SAK-80: orgNummer stored as int in backend, but is kept as string due to validation
      kjoretoyMerkeId: state.kjoretoyMerkeId,
      aktivertDato: state.aktivertDato,
      deaktivertDato: state.deaktivertDato && endOfDay(state.deaktivertDato),
      adresse1: state.adresse1,
      adresse2: state.adresse2,
      poststed: state.poststed,
      postnummer: state.postnummer,
    };
    dispatch(postAktor(payload))
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Legg til ny" }));
  };

  const saveAndClose = () => {
    if (isValid()) handlePost();
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Legg til ny aktør"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={OpenModalComponent}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <AktorerForm
          kjoretoyMerkeId={state.kjoretoyMerkeId}
          kjoretoyMerker={kjoretoyMerker}
          orgNummer={state.orgNummer}
          adresse1={state.adresse1}
          adresse2={state.adresse2}
          poststed={state.poststed}
          postnummer={state.postnummer}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          validationError={state.validationError}
          handleChange={handleChange}
        />
      </ModalGeneric>
    </>
  );
}
